import React from 'react'
import {useNavigate} from 'react-router-dom'
import useUser from 'hooks/useUser'
import {createAlert} from 'services/alerts'
import type {Alert as AlertType} from 'services/types'
import Path from 'routeLinks'
import AlertWizard from 'components/alerts/AlertWizard'

const CreateAlert: React.FC = () => {
  const {user} = useUser()
  const navigate = useNavigate()

  const saveAlert = async (a: AlertType) => {
    try {
      const {id} = await createAlert({...a, owner: user || undefined})
      navigate(Path.alerts.show(id))
    } catch (e) {
      const error = await e
      return 'Error while creating alert: ' + error
    }
    return null
  }

  return (
    <AlertWizard
      title="Create an alert"
      onCancel={() => navigate(Path.alerts.all())}
      onSave={saveAlert}
      basic
      triggers
      notifications
    />
  )
}

export default CreateAlert
